import Axios from "axios";

export const getDescriptionData = (queryString, cb) => {
    const url = `/vendorapis/products/ajax/getAIdesc?${queryString}`
    Axios.get(url).then(rsp => {
        const res = rsp.data
        if (res.errors.code) {
            cb({ status: false, value: "", msg: res.errors.msg });
        } else {
            cb({ status: true, value: res?.results || "" });
        }
    }).catch(err => {
        cb({ status: false, value: "", msg: err.message || err.msg || "Somwthing went wrong" });
    })
}